export default "__VITE_ASSET__C008TBtE__"